import { useMemo, useState } from 'react';
import ActionSheet from 'devextreme-react/action-sheet';
import { Button, ButtonTheme } from '@apply/components';
import { ButtonBorderRadius } from '@apply/components/src/components/controls/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { IBridgeApplicationGridRecord } from '@apply/api/src/api/applicationApi';
import { ApplicationStatusType } from '@apply/constants';
import { InformModal } from '../../../../../../../common/SharedComponents';
import { getApplicationActions } from '../../../../../../../applications/common/ApplicationFunctions';
import { IAppAction, IAppRowActionOptions } from '../../../../../../../applications/common/functions/applicationActions';
import { PropertyStatusType } from '../../../../../../../applications/common/ApplicationConstants';

export interface AppActionsButtonProps {
    application: IBridgeApplicationGridRecord | undefined;
    parentElementId?: string;
}

const toActionOptions = (application: IBridgeApplicationGridRecord): IAppRowActionOptions => ({
    id: application.applicationId,
    propertyId: application.propertyId,
    loanTypeId: application.loanTypeId,
    appStatusId: application.applicationStatusTypeId as ApplicationStatusType,
    propertyStatusId: application.propertyStatusTypeId as PropertyStatusType,
    isPortfolio: application.isPortfolio,
    disabled: false,
    canConvertToLoan: application.canConvertToLoan,
});

export const AppActionsButton = ({ application, parentElementId }: AppActionsButtonProps) => {
    const [sheet, setSheet] = useState<{ visible: boolean; target: string | null }>({ visible: false, target: null });
    const [informModalOpen, setInformModalOpen] = useState(false);

    // Application-level actions only (isPropertyLevel = false)
    const actions = useMemo<IAppAction[]>(
        () => (application ? getApplicationActions(toActionOptions(application), false) : []),
        [application]
    );

    if (!application) {
        return null;
    }

    const buttonId = `action_bridge_applications_${parentElementId ?? ''}_${application.applicationId}_${application.propertyId}`;

    const onButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (actions.length === 0) {
            setInformModalOpen(true);
            return;
        }
        setSheet({ visible: true, target: `#${buttonId}` });
    };

    const onActionItemClick = () => {
        alert('Actions Menu Click in Development');
        // setSheet((s) => ({ ...s, visible: false }));
        // onApplicationActionItem(store.dispatch, e.itemData.id, e.itemData.applicationId, e.itemData.propertyId);
    };

    return (
        <>
            <Button
                id={buttonId}
                hint='Click to see options'
                handleClick={onButtonClick}
                disabled={actions.length === 0}
                theme={ButtonTheme.GridGrey}
                borderRadius={ButtonBorderRadius.Small}
                height='20px'
                width='24px'
            >
                <FontAwesomeIcon icon={faEllipsis} />
            </Button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                showTitle={false}
                visible={sheet.visible}
                target={sheet.target}
                items={actions}
                onItemClick={onActionItemClick}
                onVisibleChange={(visible) => setSheet((s) => (s.visible === visible ? s : { ...s, visible }))}
            />
            <InformModal
                isOpen={informModalOpen}
                text='No actions available'
                confirmCallback={() => setInformModalOpen(false)}
            />
        </>
    );
};
